<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>人员考勤状态 使用说明:<br>
					<span>略。</span><br>
				</h5>
			</div>
		</div>

		<pre-base :pre_data="init_data">
			<!-- <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="refresh_data">查询待完成</button>
      </template> -->
		</pre-base>
	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_easy.vue")
		},
		data() {
			return {
				init_data: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init() {
				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "recordclass",
					"title": "考勤状态类型",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": "exp_kq_rec_class",
					"upd_action": "exp15_kq_rec_class",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',		
					"parm_sel": [
						
					],
					"parm": [
						{
							"name": "名称",
							"val": "",
							"key": "name",
							"type": "text",
							"class": "long1",
							"w": "1",
							"p": '1',
							"x":"1",
							"r":"0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": '1',
							"x":"1",
							"r":"0"
						}
					],
					"parm_th": [{
						"name": "序号"
					}, {
						"name": "名称"
					}, {
						"name": "标识"
					}, {
						"name": "说明"
					}, {
						"name": "状态"
					}, {
						"name": "录入人"
					}, {
						"name": "更新时间"
					}],
					"d_parm": [],
					"d_name": []
				});
			}

		}
	};
</script>
<style scoped>
</style>